// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddressList-module__addressContainer___maBBr {
    justify-content: center;
    margin-top: 190px;
    width: 100%;
    padding: 1.55rem;
    margin: 90px 5rem 3rem 5rem;
    height: calc(100vh - 225px);
    background: white;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    z-index: 1;
}

.AddressList-module__stickyHeader___Qkysp {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    padding: 1rem;
    border-bottom: 1px solid #ddd;
}

.AddressList-module__searchBar___kRF1S {
    width: 100%;
    margin-bottom: 1rem;
    padding: 0.5rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
}

    .AddressList-module__searchBar___kRF1S:focus {
        border-color: #007bff;
        outline: none;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }

.AddressList-module__tableContainer___Z1Kzx {
    flex-grow: 1;
    overflow-y: auto;
    max-height: calc(100vh - 300px);
    border-radius: 4px;
}

.AddressList-module__table___XrX5d {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
}

    .AddressList-module__table___XrX5d thead {
        position: sticky;
        top: 0px;
        background: white;
        z-index: 5;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    .AddressList-module__table___XrX5d th, .AddressList-module__table___XrX5d td {
        padding: 0.75rem;
        border-bottom: 1px solid #dee2e6;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }

        .AddressList-module__table___XrX5d th:hover {
            background-color: #f2f2f2;
        }

    .AddressList-module__table___XrX5d tbody tr:hover {
        background-color: #f8f8f8;
    }

.AddressList-module__address___BJjA3 {
    flex-grow: 1;
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    min-width: 200px;
    max-width: auto;
}

/*.table th:not(.address),
.table td:not(.address) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}*/

.AddressList-module__table___XrX5d td.AddressList-module__designCol___VX2lN,
.AddressList-module__table___XrX5d td.AddressList-module__statusCol___y7Zzw {
    min-width: 180px;
}

.AddressList-module__table___XrX5d td.AddressList-module__pictureCol___QAyVf {
    min-width: 115px;
}


.AddressList-module__design___qEW1E {
    flex-grow: 1;
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    max-width: auto;
}

.AddressList-module__status___aKu12 {
    flex-grow: 1;
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    max-width: auto;
}

.AddressList-module__expandedRow___FkvHU {
    background-color: #f8f9fa;
}

.AddressList-module__expandedContent___F1Uxa {
/*    padding: 1rem;
    background: #f1f1f1;
    border-radius: 4px;*/
}

.AddressList-module__clickableStatus___df3xu {
    cursor: pointer;
    color: var(--bmo-primary-color-mint);
}

    .AddressList-module__clickableStatus___df3xu:hover {
        text-decoration: underline;
    }

.AddressList-module__imageColumn___sp90P {
    width: 100px;
    text-align: center;
    vertical-align: middle;
    display: block;
}

.AddressList-module__thumbnailImage___yAq3Q {
    max-width: 50px;
    max-height: 50px;
    display: block;
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
    transition: transform 0.2s ease;
    object-fit: cover;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

    .AddressList-module__thumbnailImage___yAq3Q:hover {
        transform: scale(1.05);
    }

.AddressList-module__largeImagePod___RJj8h {
    max-width: 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.AddressList-module__paginationContainer___guJ0W {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-top: 1px solid #ddd;
    width: 100%;
    position: relative;
}

.AddressList-module__paginationCenter___dQftt {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
}

.AddressList-module__triggerPagination___J1Gpi {
    margin-left: auto!important;
}

.AddressList-module__paginationButton___P1z0y {
    margin: 0px 5px 0px 5px;
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 10px;
    border: 0px;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    height: 100%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
}

    .AddressList-module__paginationButton___P1z0y:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

    .AddressList-module__paginationButton___P1z0y:disabled {
        background: #ccc;
        border-color: #ccc;
        cursor: not-allowed;
    }
   

@media (max-width: 1400px) {
    .AddressList-module__addressContainer___maBBr {
        width: 90%;
    }
}

@media (max-width: 1200px) {
    .AddressList-module__addressContainer___maBBr {
        width: 95%;
    }
}


.AddressList-module__modalOverlay___nIfbA {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000 !important;
    transform: none !important;
}

.AddressList-module__modalContent___o7h17 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90vw;
    height: 90vh;
}

.AddressList-module__modalBody___QW4bO {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.AddressList-module__imageContainer___CdC5O {
    display: flex;
    align-items: center;
    justify-content: center;
}

.AddressList-module__modalImage___Emawu {
    max-width: 60vw;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 5px;
}

.AddressList-module__closeButton___O3Dfr {
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    font-size: 24px;
    padding: 10px;
    cursor: pointer;
    border-radius: 5px;
}

.AddressList-module__prevButton___dxR42,
.AddressList-module__nextButton___Zfixg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    font-size: 32px;
    padding: 15px;
    cursor: pointer;
    border-radius: 5px;
}

.AddressList-module__prevButton___dxR42 {
    left: 20px;
}

.AddressList-module__nextButton___Zfixg {
    right: 20px;
}

.AddressList-module__imageColumn___sp90P {
    display: flex;
    justify-content: center;
    align-items: center;
}

.AddressList-module__thumbnailImage___yAq3Q {
    width: 50px;
    height: 50px;
    cursor: pointer;
    border-radius: 5px;
    transition: transform 0.2s ease-in-out;
}

    .AddressList-module__thumbnailImage___yAq3Q:hover {
        transform: scale(1.1);
    }

.AddressList-module__imageDetails___U8xkD {
    width: 35%;
    padding-right: 20px;
    font-size: 16px;
    color: white;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}

.AddressList-module__detailText___ONNsh {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/AddressList/AddressList.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;AACnB;;IAEI;QACI,qBAAqB;QACrB,aAAa;QACb,0CAA0C;IAC9C;;AAEJ;IACI,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;QAChB,QAAQ;QACR,iBAAiB;QACjB,UAAU;QACV,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,gCAAgC;QAChC,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;;QAEI;YACI,yBAAyB;QAC7B;;IAEJ;QACI,yBAAyB;IAC7B;;AAEJ;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;EAKE;;AAEF;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;AACA;;wBAEwB;AACxB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;IAEI;QACI,0BAA0B;IAC9B;;AAEJ;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;IACjB,wCAAwC;AAC5C;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,+CAA+C;IAC/C,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,sGAAsG;AAC1G;;IAEI;QACI,oDAAoD;IACxD;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;;AAGJ;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sCAAsC;AAC1C;;IAEI;QACI,qBAAqB;IACzB;;AAEJ;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".addressContainer {\n    justify-content: center;\n    margin-top: 190px;\n    width: 100%;\n    padding: 1.55rem;\n    margin: 90px 5rem 3rem 5rem;\n    height: calc(100vh - 225px);\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    z-index: 1;\n}\n\n.stickyHeader {\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n    padding: 1rem;\n    border-bottom: 1px solid #ddd;\n}\n\n.searchBar {\n    width: 100%;\n    margin-bottom: 1rem;\n    padding: 0.5rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-size: 1rem;\n}\n\n    .searchBar:focus {\n        border-color: #007bff;\n        outline: none;\n        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n    }\n\n.tableContainer {\n    flex-grow: 1;\n    overflow-y: auto;\n    max-height: calc(100vh - 300px);\n    border-radius: 4px;\n}\n\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto;\n}\n\n    .table thead {\n        position: sticky;\n        top: 0px;\n        background: white;\n        z-index: 5;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    }\n\n    .table th, .table td {\n        padding: 0.75rem;\n        border-bottom: 1px solid #dee2e6;\n        text-align: left;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        cursor: pointer;\n    }\n\n        .table th:hover {\n            background-color: #f2f2f2;\n        }\n\n    .table tbody tr:hover {\n        background-color: #f8f8f8;\n    }\n\n.address {\n    flex-grow: 1;\n    white-space: normal;\n    word-wrap: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;\n    min-width: 200px;\n    max-width: auto;\n}\n\n/*.table th:not(.address),\n.table td:not(.address) {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}*/\n\n.table td.designCol,\n.table td.statusCol {\n    min-width: 180px;\n}\n\n.table td.pictureCol {\n    min-width: 115px;\n}\n\n\n.design {\n    flex-grow: 1;\n    white-space: normal;\n    word-wrap: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;\n    max-width: auto;\n}\n\n.status {\n    flex-grow: 1;\n    white-space: normal;\n    word-wrap: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;\n    max-width: auto;\n}\n\n.expandedRow {\n    background-color: #f8f9fa;\n}\n\n.expandedContent {\n/*    padding: 1rem;\n    background: #f1f1f1;\n    border-radius: 4px;*/\n}\n\n.clickableStatus {\n    cursor: pointer;\n    color: var(--bmo-primary-color-mint);\n}\n\n    .clickableStatus:hover {\n        text-decoration: underline;\n    }\n\n.imageColumn {\n    width: 100px;\n    text-align: center;\n    vertical-align: middle;\n    display: block;\n}\n\n.thumbnailImage {\n    max-width: 50px;\n    max-height: 50px;\n    display: block;\n    cursor: pointer;\n    border-radius: 4px;\n    margin: 4px;\n    transition: transform 0.2s ease;\n    object-fit: cover;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n    .thumbnailImage:hover {\n        transform: scale(1.05);\n    }\n\n.largeImagePod {\n    max-width: 100px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.paginationContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    border-top: 1px solid #ddd;\n    width: 100%;\n    position: relative;\n}\n\n.paginationCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n}\n\n.triggerPagination {\n    margin-left: auto!important;\n}\n\n.paginationButton {\n    margin: 0px 5px 0px 5px;\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 10px;\n    border: 0px;\n    border-radius: 8px;\n    transition: background-color 0.3s ease;\n    height: 100%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n}\n\n    .paginationButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n    .paginationButton:disabled {\n        background: #ccc;\n        border-color: #ccc;\n        cursor: not-allowed;\n    }\n   \n\n@media (max-width: 1400px) {\n    .addressContainer {\n        width: 90%;\n    }\n}\n\n@media (max-width: 1200px) {\n    .addressContainer {\n        width: 95%;\n    }\n}\n\n\n.modalOverlay {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000 !important;\n    transform: none !important;\n}\n\n.modalContent {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 90vw;\n    height: 90vh;\n}\n\n.modalBody {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n}\n\n.imageContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.modalImage {\n    max-width: 60vw;\n    max-height: 80vh;\n    object-fit: contain;\n    border-radius: 5px;\n}\n\n.closeButton {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: rgba(0, 0, 0, 0.7);\n    color: white;\n    border: none;\n    font-size: 24px;\n    padding: 10px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.prevButton,\n.nextButton {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(0, 0, 0, 0.7);\n    color: white;\n    border: none;\n    font-size: 32px;\n    padding: 15px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.prevButton {\n    left: 20px;\n}\n\n.nextButton {\n    right: 20px;\n}\n\n.imageColumn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.thumbnailImage {\n    width: 50px;\n    height: 50px;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: transform 0.2s ease-in-out;\n}\n\n    .thumbnailImage:hover {\n        transform: scale(1.1);\n    }\n\n.imageDetails {\n    width: 35%;\n    padding-right: 20px;\n    font-size: 16px;\n    color: white;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n}\n\n.detailText {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addressContainer": `AddressList-module__addressContainer___maBBr`,
	"stickyHeader": `AddressList-module__stickyHeader___Qkysp`,
	"searchBar": `AddressList-module__searchBar___kRF1S`,
	"tableContainer": `AddressList-module__tableContainer___Z1Kzx`,
	"table": `AddressList-module__table___XrX5d`,
	"address": `AddressList-module__address___BJjA3`,
	"designCol": `AddressList-module__designCol___VX2lN`,
	"statusCol": `AddressList-module__statusCol___y7Zzw`,
	"pictureCol": `AddressList-module__pictureCol___QAyVf`,
	"design": `AddressList-module__design___qEW1E`,
	"status": `AddressList-module__status___aKu12`,
	"expandedRow": `AddressList-module__expandedRow___FkvHU`,
	"expandedContent": `AddressList-module__expandedContent___F1Uxa`,
	"clickableStatus": `AddressList-module__clickableStatus___df3xu`,
	"imageColumn": `AddressList-module__imageColumn___sp90P`,
	"thumbnailImage": `AddressList-module__thumbnailImage___yAq3Q`,
	"largeImagePod": `AddressList-module__largeImagePod___RJj8h`,
	"paginationContainer": `AddressList-module__paginationContainer___guJ0W`,
	"paginationCenter": `AddressList-module__paginationCenter___dQftt`,
	"triggerPagination": `AddressList-module__triggerPagination___J1Gpi`,
	"paginationButton": `AddressList-module__paginationButton___P1z0y`,
	"modalOverlay": `AddressList-module__modalOverlay___nIfbA`,
	"modalContent": `AddressList-module__modalContent___o7h17`,
	"modalBody": `AddressList-module__modalBody___QW4bO`,
	"imageContainer": `AddressList-module__imageContainer___CdC5O`,
	"modalImage": `AddressList-module__modalImage___Emawu`,
	"closeButton": `AddressList-module__closeButton___O3Dfr`,
	"prevButton": `AddressList-module__prevButton___dxR42`,
	"nextButton": `AddressList-module__nextButton___Zfixg`,
	"imageDetails": `AddressList-module__imageDetails___U8xkD`,
	"detailText": `AddressList-module__detailText___ONNsh`
};
export default ___CSS_LOADER_EXPORT___;
